import { AbstractControl, ValidationErrors } from '@angular/forms';
import { SelectOption } from '@shared/form-fields/select/select.component';
import { isPostcodeInState } from '@core/administrative-areas';

export const postcodeStateMatchValidator = (group: AbstractControl): ValidationErrors | null => {
	const postcode = group.get('post_code')?.value as string | null;
	const state = group.get('state')?.value as SelectOption | null;

	if (!postcode || !state?.id) {
		return null;
	}

	return isPostcodeInState(postcode, String(state.id)) ? null : { postcodeStateMismatch: true };
};
